import { DatePipe } from "@angular/common";
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PopoverComponent } from "../../../shared/popover/popover.component";
import { FilterType } from "../../../models/enums";
import { FilterService } from "../../../services/filter.service";
import { AutoUnsubscribe } from "../../../shared/decorators";

@Component({
  standalone: false,
  selector: "dua-time-filter",
  templateUrl: "./time-filter.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./../filters.component.scss"],
})
@AutoUnsubscribe()
export class TimeFilterComponent implements OnInit, OnDestroy {
  @ViewChild("popover") popover!: PopoverComponent;

  open = false;
  fromDate!: Date;
  toDate!: Date;
  filterType = FilterType.Time;
  displayDates = "";

  dateChangeSubscription!: Subscription;
  currentOpenFilterSubscription!: Subscription;
  resetSubscription!: Subscription;

  constructor(
    private filterService: FilterService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.populateDateFilter();
    this.subscribeToChanges();
    this.resetFilter();
  }

  isDisabled(): boolean {
    return this.filterService.isDisabled();
  }

  populateDateFilter() {
    this.fromDate = this.filterService.getFilter().fromDate;
    this.toDate = this.filterService.getFilter().toDate;
    this.generateDisplayValue();
  }

  subscribeToChanges() {
    this.dateChangeSubscription = this.filterService
      .getFilterChanges()
      .subscribe((change) => {
        this.updateDates([change.fromDate, change.toDate]);
      });
    this.currentOpenFilterSubscription = this.filterService
      .getCurrentOpenedFilterChanged()
      .subscribe((filterType) => {
        if (filterType != this.filterType) {
          this.closePopover();
        }
      });
  }

  resetFilter() {
    this.resetSubscription = this.filterService
      .getResetFilterTrigger()
      .subscribe(() => {
        this.populateDateFilter();
      });
  }

  onToggle(payload: { open: boolean; event: Event }) {
    this.popover?.toggle(payload.event);
  }

  onPopoverShow() {
    this.open = true;
    this.filterService.setCurrentFilterType(this.filterType);
  }

  onPopoverHide() {
    this.open = false;
  }

  closePopover() {
    this.popover?.hide();
    this.open = false;
  }

  updateDates(dates: Date[]) {
    this.fromDate = dates[0];
    this.toDate = dates[1];
    this.generateDisplayValue();
  }

  generateDisplayValue() {
    const from = this.fromDate
      ? this.datePipe.transform(this.fromDate, "shortTime")
      : "från";
    const to = this.toDate
      ? this.datePipe.transform(this.toDate, "shortTime")
      : "till";
    this.displayDates = `${from}-${to}`;
  }

  ngOnDestroy() {}
}
